module.exports = __webpack_public_path__ + "assets/img/1413.d9e21040.svg";